<template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row header-title mb-4">
                    <h1>Метрики A/B тестов</h1>
                </div>
            </vs-col>
        </vs-row>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/3 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Страна </label>
                    <v-select
                        :options="dicts.countries"
                        label="name"
                        value="id"
                        placeholder="Выберите страну"
                        class="w-full"
                        v-bind:class="{ 'select-error': !!errors.countryId }"
                        v-model="form.countryId"
                        :reduce="(a) => a.id"
                    >
                    </v-select>
                    <div
                        v-if="errors.countryId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.countryId }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <label class="vs-input--label"> SSP Тип </label>
                <v-select
                    item-value="first"
                    :options="sspTypes"
                    :clearable="false"
                    placeholder="Выберите тип ssp"
                    class="w-full"
                    v-model="form.sspType"
                >
                </v-select>
            </div>
            <div class="vx-col w-1/3">
                <label class="vs-input--label"> Дата </label>
                <date-picker
                    :not-before="disabledBefore"
                    :not-after="disabledAfter"
                    v-model="form.createdAt"
                    type="date"
                    format="YYYY-MM-DD"
                    placeholder="Выберите дату"
                    :lang="'ru'"
                    :firstDayOfWeek="1"
                    class="date-p w-full"
                >
                </date-picker>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-1/6 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-2" color="success" @click="loadMetrics()" type="filled"> Применить </vs-button>
                </div>
            </div>
        </div>

        <vs-table :data="metrics" max-items="10" class="mt-5">
            <template slot="thead">
                <vs-th> Метрика </vs-th>
                <vs-th> Значение </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.name }}</vs-td>
                    <vs-td>{{ tr.value }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import DatePicker from 'vue2-datepicker';
let startPeriod = new Date(2022, 10, 23); // Дата начала сбора метрик
let endPeriod = new Date(); // Максимальный период до вчерашней даты
export default {
    name: 'metrics',
    data() {
        return {
            metrics: [],
            disabledBefore: startPeriod,
            disabledAfter: endPeriod,
            sspTypes: [
                {
                    label: 'Все',
                    value: '0'
                },
                {
                    label: 'Сайты',
                    value: '2'
                },
                {
                    label: 'Витрина',
                    value: '1'
                }
            ],
            form: {
                createdAt: undefined,
                sspType: { label: 'Все', value: '0' },
                countryId: undefined
            },
            errors: {
                name: '',
                status: null
            },
            dicts: {
                countries: []
            }
        };
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios;
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            // TODO change source
            this.axios.get('countries').then((countries) => {
                this.dicts.countries = countries.data;
                this.$vs.loading.close('#loader > .con-vs-loading');
            });
        },
        loadMetrics() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                countryId: this.form.countryId ? this.form.countryId : 0,
                createdAt: this.form.createdAt,
                sspGroupId: this.form.sspType.value != '0' ? this.form.sspType.value : null
            };

            this.axios
                .all([
                    this.axios.get('AbTestAdMetrics', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((metrics) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.metrics = metrics.data;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки метрик.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setDefaultValues() {
            let d = new Date();
            let today = this.$moment(d).format('YYYY-MM-DD');
            this.form.createdAt = today;
        }
    },
    mounted() {
        this.setDefaultValues();
        this.loadData();
        this.loadMetrics();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}

.change-category {
    width: 200px;
}
</style>
<style scoped>
th >>> div {
    float: right;
}

tr >>> .vs-table--td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px;
    text-align: right;
    font-family: sans-serif;
    font-size: 16px;
}
</style>